import Box from '@mui/material/Box'
import ButtonBase from '@mui/material/ButtonBase'
import Typography from '@mui/material/Typography'
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded'

export default function UserSettingsButton() {
    
    return (
        <ButtonBase
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                //backgroundColor: 'customBeige.main',
                backgroundColor: 'customGrey.main',
                paddingX: 1.5,
                paddingY: 1.5,
                paddingRight: 2.2,
                borderRadius: 5,
                color: 'primary.main',
                "&.Mui-focusVisible": {
                    //backgroundColor: 'customBeige.dark',
                    backgroundColor: 'customGrey.dark',
                },
                //boxShadow: '0 1px 3px rgba(0, 0, 0, .25)',
            }}
            component="a"
            href="/sign_out"
        >
            <Box sx={{
                paddingRight: 1.5,
                fontSize: '1.5rem',
                lineHeight: 0,
            }}>
                <AccountCircleRoundedIcon fontSize='inherit'/>
            </Box>
            <Typography component="div" sx={{ fontSize: '1rem', fontWeight: 500 }}>Účet</Typography>
        </ButtonBase>
    )
}
